import { render, staticRenderFns } from "./MenuInsightsMajorGroupOffline.vue?vue&type=template&id=1a2d9a17&"
import script from "./MenuInsightsMajorGroupOffline.vue?vue&type=script&lang=js&"
export * from "./MenuInsightsMajorGroupOffline.vue?vue&type=script&lang=js&"
import style0 from "./MenuInsightsMajorGroupOffline.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import Scroll from 'quasar/src/directives/Scroll.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'directives', {Scroll});
